import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
	selector: 'nha-base-component',
	template: '',
	standalone: false
})
export abstract class BaseComponent implements AfterViewInit, OnDestroy {
	public viewInitd$: Subject<boolean> = new Subject<boolean>();
	protected componentDestroyed$: Subject<boolean> = new Subject<boolean>();

	ngAfterViewInit(): void {
		setTimeout(() => {
			this.viewInitd$.next(true);
		}, 0);
	}

	ngOnDestroy(): void {
		this.componentDestroyed$.next(true);
		this.componentDestroyed$.complete();
		this.viewInitd$.complete();
	}
}
